// extracted by mini-css-extract-plugin
module.exports = {"widgetList":"RolesWidget_widgetList__1dhwk","widgetListItem":"RolesWidget_widgetListItem__3cHhY"};